import * as DialogPrimitive from "@radix-ui/react-dialog"
import {DatabaseZap, MonitorSmartphone, ShieldCheck, XIcon} from "lucide-react"
import {cn} from "../../lib/utils"
import type {AnonymousWarningModalProps} from "./types"

export function AnonymousWarningModal({
    open,
    onOpenChange,
    onSignIn,
    onContinueAnonymous,
    translations: t,
}: AnonymousWarningModalProps) {
    return (
        <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
            <DialogPrimitive.Portal>
                <DialogPrimitive.Overlay
                    className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50"
                />
                <DialogPrimitive.Content
                    className={cn(
                        "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
                        "fixed top-[50%] left-[50%] z-50 grid w-full max-w-sm translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200",
                    )}
                >
                    <div className="flex flex-col gap-2 text-center sm:text-left">
                        <DialogPrimitive.Title className="text-lg leading-none font-semibold">
                            {t.title}
                        </DialogPrimitive.Title>
                        <DialogPrimitive.Description className="text-sm text-muted-foreground pt-1">
                            {t.description}
                        </DialogPrimitive.Description>
                    </div>

                    <div className="flex flex-col gap-3 py-1">
                        <div className="flex items-start gap-3">
                            <ShieldCheck className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                            <p className="text-sm text-foreground">{t.donationDataRisk}</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <DatabaseZap className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                            <p className="text-sm text-foreground">{t.dataDeletionRisk}</p>
                        </div>
                        <div className="flex items-start gap-3">
                            <MonitorSmartphone className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                            <p className="text-sm text-foreground">{t.multiDeviceRisk}</p>
                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        <button
                            className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow hover:bg-primary/90 h-9 px-4 py-2 w-full"
                            onClick={onSignIn}
                        >
                            {t.signInButton}
                        </button>
                        <button
                            className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2 w-full text-muted-foreground"
                            onClick={onContinueAnonymous}
                        >
                            {t.continueAnonymousButton}
                        </button>
                    </div>

                    <DialogPrimitive.Close className="ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4">
                        <XIcon />
                        <span className="sr-only">Close</span>
                    </DialogPrimitive.Close>
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    )
}
